<template>
	<div id="companies" class="page">
		<datatable
			model="companies"
			modal="Company"
		>
		</datatable>
		<router-view />
	</div>
</template>

<script>
import { mapMutations } from 'vuex'
import Datatable from '../components/Elements/Datatable'

export default {
  name: 'Companies',
  components: {
    Datatable
  },
  data () {
    return {
      //
    }
  },
  computed: {
    //
  },
  methods: {
    ...mapMutations([
      'setPageTitle'
    ])
  },
  created () {
    this.setPageTitle('Companies')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Companies.vue